
const list = {
  path: 'list',
  component: resolve => require(['../../../../../pages/modules/cloudMarket/list'], resolve),
}

export default list
